module.exports = __webpack_public_path__ + "media/dad-card-game-detail_optimized.59bfa6d1.mp4";